const collection = [
  { id: 1, name: "NFT 1", categoryId: 2 },
  { id: 2, name: "NFT 2", categoryId: 3 },
  { id: 24, name: "NFT 3", categoryId: 3 },
  {
    id: "ercan",
    imageURL:
      "https://ipfs.io/ipfs/bafkreibittpy6uhs5dkiw3q4vd5bk4thbwzithm4f77ct55xtaqs4s3u4a",
    name: "NFT 4",
    categoryId: 1,
  },
  { id: 5, name: "NFT 5", categoryId: 3 },
  { id: 6, name: "NFT 6", categoryId: 2 },
  { id: 7, name: "NFT 7", categoryId: 2 },
  { id: 8, name: "NFT 8", categoryId: 3 },
  { id: 9, name: "NFT 9", categoryId: 3 },
  { id: 10, name: "NFT 10", categoryId: 1 },
  { id: 11, name: "NFT 11", categoryId: 2 },
  { id: 12, name: "NFT 12", categoryId: 3 },
  { id: 13, name: "NFT 13", categoryId: 2 },
  { id: 14, name: "NFT 14", categoryId: 3 },
  { id: 15, name: "NFT 15", categoryId: 1 },
  { id: 16, name: "NFT 16", categoryId: 1 },
  { id: 17, name: "NFT 17", categoryId: 2 },
  { id: 18, name: "NFT 18", categoryId: 1 },
  { id: 19, name: "NFT 19", categoryId: 1 },
  { id: 20, name: "NFT 20", categoryId: 3 },
  { id: 21, name: "NFT 21", categoryId: 2 },
  { id: 22, name: "NFT 22", categoryId: 3 },
  { id: 23, name: "NFT 23", categoryId: 3 },
  { id: 3, name: "NFT 24", categoryId: 3 },
  { id: 25, name: "NFT 25", categoryId: 3 },
  { id: 26, name: "NFT 26", categoryId: 2 },
  { id: 27, name: "NFT 27", categoryId: 2 },
  { id: 28, name: "NFT 28", categoryId: 3 },
  { id: 29, name: "NFT 29", categoryId: 3 },
  { id: 30, name: "NFT 30", categoryId: 2 },
  { id: 31, name: "NFT 31", categoryId: 3 },
  { id: 32, name: "NFT 32", categoryId: 2 },
  { id: 33, name: "NFT 33", categoryId: 1 },
  { id: 34, name: "NFT 34", categoryId: 2 },
  { id: 35, name: "NFT 35", categoryId: 2 },
  { id: 36, name: "NFT 36", categoryId: 2 },
  { id: 37, name: "NFT 37", categoryId: 1 },
  { id: 38, name: "NFT 38", categoryId: 3 },
  { id: 39, name: "NFT 39", categoryId: 3 },
  { id: 40, name: "NFT 40", categoryId: 2 },
  { id: 41, name: "NFT 41", categoryId: 2 },
  { id: 42, name: "NFT 42", categoryId: 1 },
  { id: 43, name: "NFT 43", categoryId: 1 },
  { id: 44, name: "NFT 44", categoryId: 2 },
  { id: 45, name: "NFT 45", categoryId: 2 },
  { id: 46, name: "NFT 46", categoryId: 2 },
  { id: 47, name: "NFT 47", categoryId: 3 },
  { id: 48, name: "NFT 48", categoryId: 1 },
  { id: 4, name: "NFT 4", categoryId: 1 },
];

export default collection;
